import { Camera } from 'lucide-react';
import Video from '../video/Video';

/* =====================================================================
   Las pantallas del carril `video` · F0 / AC-20
   =====================================================================
   Una pantalla, por permiso `video.ver` (520), en el grupo de Planta y
   aparatos. Sin cámaras dice que no hay motor; no pinta verde.
   ===================================================================== */
export default {
  orden: 46,
  grupos: [{
    grupo: 'Planta y aparatos',
    items: [
      { id: 'video', etiqueta: 'Video', icono: Camera, permiso: 'video.ver', min: 'ADMIN', soloEmpresa: true, Comp: Video },
    ],
  }],
};
